import React, {FunctionComponent} from 'react';

type TitleCaptionProps = {
  subtitle?: string
}

const TitleCaption: FunctionComponent<TitleCaptionProps> = ({subtitle, children}) =>
  (
    <>
      <div className="flex flex-col pr-4">
        <div className="text-2xl">{children}</div>
        {subtitle &&
        <div className="text-base text-gray-dark">{subtitle}</div>}
      </div>
    </>
  );

export default TitleCaption;
